import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "implemented-validations"
    }}>{`Implemented Validations`}</h1>
    <p>{`This document catalogues what validation rules are in place for element creation payloads.
We assume general familiarity with Libraries, and the element creation process.`}</p>
    <h2 {...{
      "id": "definitions"
    }}>{`Definitions`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Term`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Definition`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`property path (column heading)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Path to property in JSON document.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`condition (column heading)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The condition that must be fulfilled for a validation to execute.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`type (column heading)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The JSON type expected for some property value, or the Java type that the JSON value will be coerced into if it is more restrictive then the JSON type and is a primitive type or the boxed equivalent. Additionally, some properties are polymorphous, and may have different validation rules associated with different types.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`empty (string)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string containing no characters, e.g., "".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`blank (string)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A string containing only whitespace, e.g., "      ".`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`always (execution condition)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates that a validation will always be performed, regardless of property value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`when present (execution condition)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates that a validation will only be performed if the property value is non-null.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`well-known (element or representation type)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An element or representation type for which we have implemented bespoke validation logic.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`well-known (property in paragraph or character style)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A style for which we have implemented bespoke validation logic.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`supported (element or representation type)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An element or representation type that can be used in requests.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`user-uploaded asset`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Binary data uploaded before a library element is created referring to the uploaded data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`concrete MIME type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A MIME type that is both valid, and does not contain wildcards, e.g., "image/*" is a valid MIME type, but is not concrete, but "image/png" is valid and concrete.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "json-property-path-legend"
    }}>{`JSON Property Path Legend`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Symbol`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`contextual document root, will refer to the last object level named in a heading`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`.aProperty`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`property access`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[1]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array index`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`.*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all properties in object`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all indexes in array`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`.{a, b, c, d}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`a specific set of possible properties`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[*]`}{`(`}{`property=value`}{`)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`a selector; all objects in the array where property=value`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "validation-and-type-coercion"
    }}>{`Validation and Type Coercion`}</h2>
    <p>{`There are effectively two layers of processes that sanitize service input. The first is the process that maps input to
models with strongly-typed properties. The second is explicit validation logic that interrogates
payload content after it has been mapped. A payload may be rejected within either layer, but, these errors will appear
differently to the service consumer. For example, if a property value should be coerced into an integer in the
mapping layer, but the JSON type of the value supplied was string, and, that string contained non-numeric
characters, then the service consumer may get a 500 in response as the type coercion would fail. However,
if we had implemented validation that enforces a range for this property, the consumer supplied a valid number that could be
coerced into an integer, and this number fell outside of the allowed range, we would return a 400. Since, in effect,
both processes sanitize input, both are accounted for in this document. `}</p>
    <p>{`A couple examples\\:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeDesiredLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between -100 and 500, inclusive`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`In this example, if the supplied value was not coercible into a number, the payload would be rejected.
If the supplied value was coercible, then the validation rule "must be between -100 and 500, inclusive"
would apply.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.vectorColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`In this example, if the supplied value was not coercible into a boolean, the payload would be rejected.
If the supplied value was coercible, no other validation would occur.`}</p>
    <h2 {...{
      "id": "mime-types-associated-with-user-uploaded-assets"
    }}>{`MIME Types Associated With User-Uploaded Assets`}</h2>
    <pre><code parentName="pre" {...{}}>{`  private static final String[] assetMimeTypes = {
      "image/*",
      "video/*",
      "text/*",
      "audio/*",
      "application/photoshop",
      "application/ai",
      "application/pdf",
      "application/zip",
      "application/postscript",
      "application/vnd.adobe.indesign-idms",
      "application/x-indesign",
      "application/vnd.adobe.muse-collection",
      "application/vnd.adobe.pstouch",
      "application/vnd.adobe.psremix",
      "application/vnd.adobe.ideas",
      "application/vnd.adobe.ase",
      "application/mxf",
      "application/x-shockwave-flash",
      "application/msword",
      "application/msexcel",
      "application/mspowerpoint",
      "application/vnd.ms-publisher",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation"
  };
`}</code></pre>
    <h2 {...{
      "id": "valid-css-units"
    }}>{`Valid CSS Units`}</h2>
    <pre><code parentName="pre" {...{}}>{`  public static final Set<String> cssUnits = Set.of(
      "%",

      // relative units
      "em",
      "ex",
      "cap",
      "ch",
      "ic",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vi",
      "vb",
      "vmin",
      "vmax",

      // absolute lengths
      "cm",
      "mm",
      "q",
      "in",
      "pt",
      "pc",
      "px",

      // angles
      "deg",
      "grad",
      "rad",
      "turn",

      // duration
      "s",
      "ms",

      // frequency
      "hz",
      "khz",

      // resolution
      "dpi",
      "dpcm",
      "dppx"
  );
`}</code></pre>
    <h2 {...{
      "id": "supported-audio-types"
    }}>{`Supported Audio Types`}</h2>
    <p>{`audio/mpeg\\
audio/x-mpeg\\
audio/mpeg3\\
audio/x-mpeg-3\\
audio/mp3\\
audio/m4a\\
audio/wav\\
audio/x-wav\\
audio/vnd.wave\\
audio/wave\\
audio/aac\\
audio/aacp\\
audio/aif\\
audio/x-aiff`}</p>
    <h2 {...{
      "id": "validation-rules"
    }}>{`Validation Rules`}</h2>
    <h3 {...{
      "id": "reference-structures"
    }}>{`Reference Structures`}</h3>
    <p>{`The following models are used in specific contexts, and are not used in representation payloads outside of those contexts.`}</p>
    <h4 {...{
      "id": "unit"
    }}>{`Unit`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid CSS measurement, case-insensitive; c.f. "Valid CSS Measurements"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "postlibraryelementpayload"
    }}>{`postLibraryElementPayload`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must have a valid MIME type that is also concrete (no wildcards)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.client`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.client.{app, deviceId, device}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.representations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.representations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cannot contain more then one representation with the 'primary' relationship`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.representations`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`each representation must be valid according to rules associated with representation type`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.source`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "postlibraryelementpayloadrepresentations"
    }}>{`postLibraryElementPayload.representations`}{`[*]`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid MIME type that is also concrete (no wildcards)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`the representation type is well-known`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`representation type must belong to the set of types associated with the element type`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.{storage_href, path}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`type matches one of the items in "MIME Types Associated With User-Uploaded Assets" list above.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`storage_href and/or path must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.linktype`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.link+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid MIME type that is also concrete (no wildcards)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.linkurl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.link+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be a blank string`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adobestock#trackingdata`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`type is "application/vnd.adobe.library.link+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.color#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.color+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.colortheme#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.colortheme+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.gradient#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.gradient+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.gradient#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.gradient.noise+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.audio#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is a supported audio type; c.f. "Supported Audio Types" above`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.font#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.font+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.characterstyle#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.characterstyle+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.paragraphstyle#data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type is "application/vnd.adobe.library.paragraphstyle+dcx"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.relationship`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.md5`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.etag`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.is_full_size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.is_external_link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`long`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.height`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`long`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.content_length`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Long`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.representation_order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.is_preferred_thumbnail`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.is_component`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "representation-type-validations"
    }}>{`Representation Type Validations`}</h3>
    <h4 {...{
      "id": "applicationvndadobecolorjson-postlibraryelementpayloadrepresentationstypeapplicationvndadobecolorjsoncolordata"
    }}>{`application/vnd.adobe.color+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.color+json).color#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.mode`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be in set {"RGB", "CMYK", "Lab", "Gray", "HSB", "RGB.tint", "CMYK.tint", "Lab.tint"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be non-null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "RGB" or "RGB.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must have keys "r", "g", and "b"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.{r, g, b}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "RGB" or "RGB.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`values must be between 0 and 255, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "CMYK" or "CMYK.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must have keys "c", "m", "y", and "k'`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.{c, m, y, k}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "CMYK" or "CMYK.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`values must be between 0 and 100, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "Lab" or "Lab.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must have keys "l", "a", and "b"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.l`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "Lab" or "Lab.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 100, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.a`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "Lab" or "Lab.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between -128 and 127, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.b`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "Lab" or "Lab.tint"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between -128 and 127, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "HSB"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must have keys "h", "s", and "b"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.h`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "HSB"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 360, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.s`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "HSB"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 100, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value.b`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "HSB"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 100, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is "Gray"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 100, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.profileName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be non-null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.alpha`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 1, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be in set {"process", "spot", "registration", "none"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.spotColorName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when type is "spot"`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be non-empty string`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.tint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when mode is one of {"RGB.tint", "CMYK.tint", "Lab.tint"}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 100, inclusive`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobecolorthemejson-postlibraryelementpayloadrepresentationstypeapplicationvndadobecolorthemejsoncolorthemedata"
    }}>{`application/vnd.adobe.colortheme+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.colortheme+json).colortheme#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.swatches`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain 5 things`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.swatches`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be an array`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.swatches`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain one application/vnd.adobe.color+json where mode is "RGB"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.swatches`}{`[*][*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`apply application/vnd.adobe.color+json validations`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.themeId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.baseSwatchIndex`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.tags`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array of strings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.rule`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.mood`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobegradientjson-postlibraryelementpayloadrepresentationstypeapplicationvndadobegradientjsongradientdata"
    }}>{`application/vnd.adobe.gradient+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.gradient+json).gradient#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`value one of {"linear", "radial"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}{`[*]`}{`.color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be an array`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}{`[*]`}{`.color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain at least one color where mode is "RGB"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}{`[*]`}{`.color`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid application/vnd.adobe.color+json`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}{`[*]`}{`.phxsInherit`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be one of {"foreground", "background"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}{`[*]`}{`.offset`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 1, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.stops`}{`[*]`}{`.midpoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.angle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 360, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.scale`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be greater than 0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.centerPoint`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain the keys "x", and "y"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.centerPoint.{x, y}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`values must be between -1 and 1, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.interpolation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be one of {"linear", "euclidean", "spline"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.opacities`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be an array`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.opacities`}{`[*]`}{`.{opacity, midpoint, offset}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 1, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.orientation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain the keys "x1", "x2", "y1", "y2"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.orientation.{x1, x2, y1, y2}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`values must be between 0 and 1`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.direction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be one of {"horizontal", "vertical" }`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.smoothness`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 4096, inclusive`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobegradientnoisejson-postlibraryelementpayloadrepresentationstypeapplicationvndadobegradientnoisejsongradientdata"
    }}>{`application/vnd.adobe.gradient.noise+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.gradient.noise+json).gradient#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.maximumColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is not null, is an array`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.minimumColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain at least one color where mode is "RGB"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.minimumColor`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is a valid application/vnd.adobe.color+json`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.maximumColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is not null, is an array`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.maximumColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`array`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain at least one color where mode is "RGB"`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.maximumColor`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is a valid application/vnd.adobe.color+json`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.randomSeed`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`is not null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.smoothness`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 4096, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.vectorColor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.showTransparency`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none (coercion only)`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobefontjson-postlibraryelementpayloadrepresentationstypeapplicationvndadobefontjsonfontdata"
    }}>{`application/vnd.adobe.font+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.font+json).font#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.family`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.postScriptName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.typekitFontId`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.foundry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobeelementcharacterstylejson-postlibraryelementpayloadrepresentationstypeapplicationvndadobecharacterstylejsoncharacterstyledata"
    }}>{`application/vnd.adobe.element.characterstyle+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.characterstyle+json).characterstyle#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must contain at least one property`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`cannot contain any properties from application/vnd.adobe.element.paragraphstyle+json that are type coerced 🚩`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be null`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.*`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present, if string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.color`}{`[*]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid application/vnd.adobe.color+json`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.fontSize`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.fontFamily`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.fontStyle`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.fontWeight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must not be blank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.fontWeight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 1 and 1000, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.lineHeight`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.baselineShift`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.letterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeFont`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid application/vnd.adobe.font+json, except, all properties are optional`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "applicationvndadobeelementparagraphstylejson-postlibraryelementpayloadrepresentationstypeapplicationvndadobeparagraphstylejsonparagraphstyledata"
    }}>{`application/vnd.adobe.element.paragraphstyle+json (postLibraryElementPayload.representations`}{`[`}{`*`}{`]`}{`(type=application/vnd.adobe.paragraphstyle+json).paragraphstyle#data)`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`always`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`any`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`all validations from application/vnd.adobe.element.characterstyle+json, except where marked 🚩`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeParaAlignment`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be one of {"Alignment.LEFT_ALIGN", "Alignment.CENTER_ALIGN", "Alignment.RIGHT_ALIGN", "Alignment.LEFT_JUSTIFIED", "Alignment.CENTER_JUSTIFIED", "Alignment.RIGHT_JUSTIFIED", "Alignment.FULLY_JUSTIFIED"}`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeLeftIndent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeFirstLineIndent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeRightIndent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeSpaceBefore`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeSpaceAfter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`object`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be a valid Unit`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeMinimumWordSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 1000, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeDesiredWordSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 1000, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeMaximumWordSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 1000, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeMinimumLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between -100 and 500, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeDesiredLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between -100 and 500, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeMaximumLetterSpacing`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between -100 and 500, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeMinimumGlyphScaling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 50 and 200, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeDesiredGlyphScaling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 50 and 200, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeMaximumGlyphScaling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 50 and 200, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeParaAutoLeading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be between 0 and 500, inclusive`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.adbeSingleWordJustification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be one of {"Justification.FULLY_JUSTIFIED", "Justification.LEFT_ALIGN", "Justification.CENTER_ALIGN", "Justification.RIGHT_ALIGN"}`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "audio-see-supported-audio-types-postlibraryelementpayloadrepresentationstypeapplicationvndadobeaudiojsonaudiodata"
    }}>{`audio/`}<em parentName="h4">{` (see Supported Audio Types) postLibraryElementPayload.representations`}{`[`}</em>{`]`}{`(type=application/vnd.adobe.audio+json).audio#data`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Condition`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Validation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.duration`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Double`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be greater than 0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.bitrate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be greater than 0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.channels`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be greater than 0`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`$.tempo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`when present`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Integer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`must be greater than 0`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      